var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgStar1 = function SvgStar1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.323 7.677c.171.1.351.174.517.203l2.015.336.095.014 1.01.17c.398.067.746.177 1.038.325.487.246.818.597.962 1.035.22.7-.08 1.51-.84 2.27l-.007.007L18.7 14.46c-.36.36-.56 1.05-.44 1.54l.69 3.01c.29 1.25.11 2.19-.51 2.64-.138.1-.291.171-.46.216-.585.16-1.354-.019-2.22-.526l-2.93-1.74c-.229-.134-.532-.202-.835-.203-.303.001-.606.069-.835.203l-2.93 1.74c-.866.507-1.635.686-2.22.526a1.384 1.384 0 0 1-.46-.216c-.62-.45-.8-1.39-.51-2.64L5.73 16c.12-.49-.08-1.18-.44-1.54l-2.413-2.423-.007-.007c-.76-.76-1.06-1.57-.84-2.27.23-.7.94-1.18 2-1.36h.003l1.007-.17c.027-.005.057-.01.09-.013l2.02-.337a1.6 1.6 0 0 0 .517-.203L7.66 7.67c.29-.17.56-.42.69-.68l1.72-3.45c.5-.99 1.18-1.54 1.92-1.54H12c.74 0 1.42.55 1.92 1.54l1.72 3.45c.13.26.4.51.69.68l-.006.007Z",
    fill: "currentColor"
  })));
};

export default SvgStar1;